export * from "./singleton";
